import { useState } from "react";
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';

const ShieldIcon = () => (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <line x1="9" y1="9" x2="15" y2="15" />
        <line x1="15" y1="9" x2="9" y2="15" />
    </svg>
);

const LockIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
);

function ForbiddenPage() {
    return (
        <div style={{
            minHeight: "90vh",
            background: "#fafafa",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            color: "#111",
            padding: "2rem",
        }}>
            <div style={{
                textAlign: "center",
                maxWidth: 480,
                width: "100%",
            }}>
                {/* Icon */}
                <div style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 96,
                    height: 96,
                    borderRadius: "50%",
                    background: "#fef2f2",
                    marginBottom: "2rem",
                }}>
                    <ShieldIcon />
                </div>

                {/* Error code */}
                <p style={{
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    letterSpacing: "0.1em",
                    textTransform: "uppercase",
                    color: "#dc2626",
                    marginBottom: "0.5rem",
                }}>
                    {i18next.t('forbiddenPage:error403')}
                </p>

                {/* Title */}
                <h1 style={{
                    fontSize: "1.75rem",
                    fontWeight: 700,
                    color: "#111",
                    marginBottom: "0.75rem",
                    lineHeight: 1.3,
                }}>
                    {i18next.t('forbiddenPage:accessDenied')}
                </h1>

                {/* Description */}
                <p style={{
                    fontSize: "1rem",
                    color: "#6b7280",
                    lineHeight: 1.7,
                    marginBottom: "2rem",
                    maxWidth: 400,
                    marginLeft: "auto",
                    marginRight: "auto",
                }}>
                    {i18next.t('forbiddenPage:description')}
                </p>

                {/* Info box */}
                <div style={{
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    borderRadius: 10,
                    padding: "1rem 1.25rem",
                    marginBottom: "2rem",
                    textAlign: "left",
                    fontSize: "0.875rem",
                    color: "#6b7280",
                    lineHeight: 1.7,
                }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#374151", fontWeight: 600, marginBottom: 8 }}>
                        <LockIcon />
                        <span>{i18next.t('forbiddenPage:why')}</span>
                    </div>
                    <ul style={{ margin: 0, paddingLeft: "1.25rem" }}>
                        <li>{i18next.t('forbiddenPage:description2')}</li>
                        <li>{i18next.t('forbiddenPage:description3')}</li>
                    </ul>
                </div>

                {/* Footer */}
                <p style={{
                    marginTop: "3rem",
                    fontSize: "0.75rem",
                    color: "#9ca3af",
                }}>
                    {i18next.t('forbiddenPage:description4')} <strong style={{ color: "#6b7280" }}>{i18next.t('forbiddenPage:forbiddenCode')}</strong>
                </p>
            </div>
        </div>
    );
}

export default withNamespaces(['forbiddenPage'], { wait: true })(ForbiddenPage);